import SinglePageHeroView from './SinglePageHeroView'


export default SinglePageHeroView
